const translations = {
  "en": {
    "500 credits": "500 credits",
    "Chat": "Chat",
    "Chat with Ed": "Chat with Ed",
    "Discover": "Discover",
    "Each gets": "Each gets",
    "Goal": "Goal",
    "Language": "Language",
    "Missions": "Missions",
    "Others": "Others",
    "Pricing": "Pricing",
    "Settings": "Settings",
    "Share Ed with a friend": "Share Ed with a friend",
    "Subscriptions": "Subscriptions"
  },
  "zh-tw": {
    "500 credits": "500 點數",
    "Chat": "聊天",
    "Chat with Ed": "與 Ed 聊天",
    "Discover": "發現",
    "Each gets": "每個都獲得",
    "Goal": "目標",
    "Language": "語言",
    "Missions": "任務",
    "Others": "其他",
    "Pricing": "定價",
    "Settings": "設定",
    "Share Ed with a friend": "與朋友分享 Ed",
    "Subscriptions": "訂閱"
  }
};

export default translations;
